import QRCode from 'qrcode.react';
import type { ChangeEvent } from 'react';
import { useState } from 'react';

import { Button, Colors } from '../../legacy/button/Button.component';
import { Panel } from '../panel/Panel.component';
import styles from './Enable2FAModal.module.css';

interface Props {
  otpAuthUrl: string;
  onVerify: (code: string) => Promise<void>;
  hideModal: () => void;
}

interface Enable2FAModalProps {
  hideModal: () => void;
}

const Enable2FA: React.FC<Props> = ({
  otpAuthUrl,
  onVerify,
  hideModal,
}: Props) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFACodeChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setCode(e.target.value);
  };

  return (
    <Panel
      className={styles.enable2FAModal}
      bodyClassName={styles.enable2FAModalBody}
      title="enable 2fa"
      hasExitModalButton={true}
      hideModal={hideModal}
    >
      <p className={styles.twoFactorAuthHeading}>
        Scan the QRCode with your authenticator app
      </p>
      <div className={styles.twoFactorQRCode}>
        <QRCode value={otpAuthUrl} />
      </div>
      <p className={styles.enable2FAText}>Code from authentication app</p>
      <input
        type="text"
        className={styles.enable2FAInputs}
        value={code}
        onChange={handleFACodeChange}
        disabled={loading}
      />
      <Button
        color={Colors.COLOR_SCHEME_2}
        className={styles.enable2FABtn}
        onClick={async () => {
          setLoading(true);
          try {
            await onVerify(code);
          } finally {
            setLoading(false);
            hideModal();
          }
        }}
        disabled={loading}
      >
        SAVE
      </Button>
    </Panel>
  );
};

export const Enable2FAModal =
  (otpAuthUrl: string, onVerify: (code: string) => Promise<void>) =>
  ({ hideModal }: Enable2FAModalProps) => {
    return (
      <Enable2FA
        otpAuthUrl={otpAuthUrl}
        onVerify={onVerify}
        hideModal={hideModal}
      />
    );
  };
